<template>
  <div class="login-container">
    <el-row type="flex" justify="center" align="middle" class="login-row">
      <el-col :xs="22" :sm="12" :md="8" :lg="6" :xl="5">
        <el-card class="login-card" shadow="always" style="background-color: rgba(255, 255, 255, 0.8);">
          <div slot="header" class="login-header">
            <!-- <img src="../assets/logo.png" alt="logo" class="login-logo" v-if="false"> -->
            <h2 class="login-title">登录</h2>
          </div>

          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-position="top">
            <el-form-item label="账号" prop="account">
              <el-input 
                v-model="loginForm.account" 
                placeholder="请输入用户名/邮箱" 
                prefix-icon="el-icon-user"
                clearable>
              </el-input>
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input 
                v-model="loginForm.password" 
                placeholder="请输入密码" 
                prefix-icon="el-icon-lock" 
                show-password
                @keyup.enter.native="handleLogin">
              </el-input>
            </el-form-item>

            <el-form-item>
              <div class="login-options">
                <el-checkbox v-model="loginForm.rememberMe">记住登录</el-checkbox>
                <!-- <el-link type="primary" :underline="false">忘记密码？</el-link> -->
              </div>
            </el-form-item>

            <el-form-item>
              <el-button 
                type="primary" 
                class="login-submit" 
                :loading="loading" 
                @click="handleLogin">
                {{ loading ? '登录中...' : '立即登录' }}
              </el-button>
            </el-form-item>
            
            <div class="register-link">
              <router-link to="/register">立即注册</router-link>
              <div style="margin-left: 20px;"><router-link to="/modifyPassword">修改密码</router-link></div>
              <div style="margin-left: 20px;"><router-link to="/modifyAll">密码重置</router-link></div>
            </div>
          </el-form>
        </el-card>
        <ICPFooter class="login-icp" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { sdk } from "../mixins";
import ICPFooter from "@/components/ICPFooter.vue";
export default {
  mixins: [sdk],
  name: 'Login',
  components: {ICPFooter},
  data() {
    return {
      loading: false,
      loginForm: {
        account: '',
        password: '',
        rememberMe: true
      },
      // 表单验证规则
      loginRules: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于 6 位', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getCookie();
  },
  methods: {
    getCookie() {
      const account = localStorage.getItem("remember_account");
      const password = localStorage.getItem("remember_password");
      if (account && password) {
        this.loginForm.account = account;
        this.loginForm.password = password;
        this.loginForm.rememberMe = true;
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const {account,password} = this.loginForm
          let data = {
            account,
            password
          }
          this.loginTyLogin(this.SDKURL, "account", {...data}).then((res) => {
            if(res.code == 200){
              let loginToken = res.data.token;
              let params = {
                  token: loginToken,
                  appid: process.env.VUE_APP_APPID
                }
              this.$api.checkLogin(params).then(resd => {
                if(resd.code == 200){
                  if (this.loginForm.rememberMe) {
                    localStorage.setItem("remember_account", account);
                    localStorage.setItem("remember_password", password);
                  } else {
                    localStorage.removeItem("remember_account");
                    localStorage.removeItem("remember_password");
                  }
                  // this.$store.commit('setUserInfo', { ...resd.data.user_info });
                  this.$store.commit('setToken', resd.data.token)
                  this.$router.push('/home')
                }
              }).finally(err => {
                this.loading = false;
              })
            }else {
              this.loading = false; 
            }
          }).catch(() => {
            this.loading = false;
          });
          
        } else {
          console.log('表单验证失败');
          this.loading = false;
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  /* 基础样式 */
  height: 100vh;
  // background: linear-gradient(135deg, #1e1e2f 0%, #3e3e5e 100%);
  background: url("@/assets/imgs/bg.png") no-repeat center center;
  background-size: cover;
  /* 核心：确保不出现滚动条 */
  overflow: hidden; 
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-row {
  width: 100%;
  height: 100%;
}

.login-card {
  border: none;
  border-radius: 12px;
  /* PC端防止卡片过长 */
  max-height: 90vh;
  overflow-y: auto;
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login-submit {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  letter-spacing: 2px;
}

.register-link {
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  color: #606266;
  margin-top: 10px;
  
  a {
    color: #409EFF;
    text-decoration: none;
  }
}

/* --- 移动端深度优化 --- */
@media screen and (max-width: 480px) {
  .login-container {
    background: url("@/assets/imgs/bg_m.png") no-repeat center center;
    background-size: 100% 100%;
    /* 彻底禁止移动端弹性滚动 */
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
  }

  .login-card {
    box-shadow: none !important;
    background: transparent;
    width: 100%;
    /* 调整移动端内边距，压缩空间防止超出屏幕 */
    padding: 0; 
    
    ::v-deep .el-card__body {
      padding: 20px;
    }
  }

  .login-submit {
    height: 44px; /* 移动端标准高度 */
    font-size: 16px;
  }

  /* 调大输入框字体，防止 iOS 点击自动放大页面 */
  ::v-deep .el-input__inner {
    font-size: 16px !important;
  }
}
</style>